// extracted by mini-css-extract-plugin
export default {"input":"DurationRangeBadge_input__ItuMQ"};